import { useEffect, useState } from 'react'
import { WeaverLoading } from 'Components'
import withDetailsContainer from './withDetailsContainer'
import PopoverContent from './AttributePopoverContent'
import DistributionIndicator from './DistributionIndicator'
import { TransformAttrToRel } from 'Components'
import { getAttributeKeyLabel, splitUid } from 'Services/WeaverUtils'
import { Row, Col, Button, Popover, Tooltip } from 'antd'
import Feather from '@sysunite/react-feather'

export default AbstractNodeDetails = ({ data }) ->
  [item, setItem] = useState(undefined)
  [loading, setLoading] = useState(true)

  useEffect( ->
    ( ->
      setLoading(true)
      [id, graph] = splitUid(data.id)
      q = new Weaver.Query().restrict([id])
      q.inGraph(graph) if graph?
      node = await q.first()

      attributesCount = await Weaver.MetaQueries.attributesAndDistinctCount(node.id(), data.memberKey, { limit: 99999, graph: node.graph })

      attributes = {}
      attributesCount.map((attribute) ->
        if attribute.distinctCount is 1 and attribute.totalCount isnt 1
          percentage = 0
        else if attribute.distinctCount is attribute.totalCount
          percentage = 100
        else
          percentage = (attribute.distinctCount * 100) / attribute.totalCount

        attributes[attribute.label] = percentage
      )
      setItem({ node, attributes, memberKey: data.memberKey })
      setLoading(false)
    )()
    undefined
  , [data])

  return <WeaverLoading style={{ margin: '33%' }} /> if loading
  Details = withDetailsContainer(item.node)

  <Details>
    {_.map(item.attributes, (val, key) ->
      {
        key,
        label:  <Tooltip title={key}>{ getAttributeKeyLabel(key) }</Tooltip>
        value: (
          <Row type="flex" align="middle">
            <Col span={17}>
              <DistributionIndicator value={val} />
            </Col>
            <Col span={2} offset={1}>
              <a
                style={{ padding: '4px 15px'}}
                onClick={(e) -> e.stopPropagation()}
              >
                <TransformAttrToRel
                  type={data.type}
                  viewType={data.viewType}
                  nodeId={data.id}
                  label={getAttributeKeyLabel(key)}
                  memberKey={data.memberKey}
                />
              </a>
            </Col>
            <Col span={2} offset={1}>
              <Popover
                content={<PopoverContent attrKey={key} item={item} />}
                placement="right"
                mouseEnterDelay={0}
              >
                <Button type="link"><span style={{ height: '100%' }}><Feather type="bar-chart-2" /></span></Button>
              </Popover>
            </Col>
          </Row>
        )
      }
    )}
  </Details>
